<template>
    <el-dialog :visible.sync="visible" title="关联商户" @close="close">
        <el-form size="small" ref="formRef" :model="form" label-width="100px">
            <el-form-item
                label="商户"
                prop="shop_ids"
                :rules="{
                    required: true,
                    message: '请选择商户',
                    trigger: 'blur',
                }"
            >
                <el-select
                    v-model="form.shop_ids"
                    filterable
                    placeholder="请选择商户"
                    multiple
                    @remove-tag="removeTag"
                >
                    <el-option
                        v-for="item in lists"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="handleSubmit"
                >确定</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import {
    apiShopLists,
    apiDistributionDistributionAddShop,
    apiDistributionDistributionRelationShop,
    apiDistributionDistributionDelShop,
} from "@/api/shop";
export default {
    data() {
        return {
            visible: false,
            id: null,
            form: {
                shop_ids: [],
            },
            lists: [],
        };
    },
    methods: {
        removeTag(e) {
            apiDistributionDistributionDelShop({
                id: this.id,
                shop_ids: [e],
            }).then((res) => {
                this.$emit("success");
            });
        },
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    apiDistributionDistributionAddShop({
                        ...this.form,
                        id: this.id,
                    }).then((res) => {
                        this.visible = false;
                        this.$emit("success");
                    });
                }
            });
        },
        open(id) {
            if (id) {
                this.id = id;
                apiShopLists({ page_type: 0, id: this.id, page_size: 25000, page_no: 1 })
                    .then((res) => {
                        this.lists = res.lists;
                        return apiDistributionDistributionRelationShop({
                            id: this.id,
                        });
                    })
                    .then((res) => {
                        if (res && res.length) {
                            this.form.shop_ids = res.map(
                                (item) => item.shop_id
                            );
                        }
                        this.visible = true;
                    });
            }
        },
        close() {
            this.id = null;
            this.form = {
                shop_ids: "",
            };
        },
    },
};
</script>
